module.exports = __webpack_public_path__ + "202408221624/img/img_card_2.54e5cf5d.png";